import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { UserService } from '../../services/user.service';
import { MagentoService } from 'src/app/services/magento.service';
import { BymeService } from 'src/app/services/byme.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { CONTEXT } from 'src/app/enum/context';
import { MAGENTO_MESSAGES } from 'src/app/enum/magento-messages';
import { CurrentService } from 'src/app/services/current.service';

@Component({
  selector: 'ng-hbm-bdi-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, AfterViewInit {

  readonly CONTEXT = CONTEXT;

  isLoading: boolean;
  customerName: string;
  customerMagentoId: string;

  constructor(private modalService: ModalService,
    public customer: UserService,
    private magentoService: MagentoService,
    private byMeService: BymeService,
    private gtm: GTM,
    private router: Router,
    private current: CurrentService) { }

  ngOnInit(): void {
    this.current.initSession();
    this.gtm.trackPage('home');
    this.magentoService.loadingState.subscribe(state => this.isLoading = state);
    if (this.customer.userDatas?.otherAccount) {
      this.customerName = this.customer.userDatas.otherAccount.completeName;
      this.customerMagentoId = this.customer.userDatas.otherAccount.magentoId;
    }

    this.customer.resetPhone();
  }

  ngAfterViewInit() {
    window.addEventListener('message', this.magentoService.handleMagentoMessage);
    if (!this.magentoService.init) {
      this.magentoService.timeoutID = setTimeout(() => this.refreshIFrameReady(), 500);
    }
  }

  refreshIFrameReady() {
    if (!this.magentoService.init) {
      this.magentoService.postMessageToMagento(MAGENTO_MESSAGES.IFRAME_READY);
      this.magentoService.timeoutID = setTimeout(() => this.refreshIFrameReady(), 500);
    }
  }

  cleanToken() {
    //si le vendeur est connecté sur son compte, on enlève le token pour éviter qu'il se logue plus tard sur byme
    if (this.customer.userDatas) {
      if (this.customer.userDatas.vendor && !this.customer.userDatas.otherAccount) {
        this.byMeService.byMeApiToken = null;
      }
    }
  }

  startNewProject(context: string) {
    this.updateContext(context);
    this.current.reset();
    if (context === CONTEXT.KITCHEN) {      
      this.gtm.trackEvent("click", "home", "start-" + CONTEXT.KITCHEN);
      this.router.navigateByUrl('/kitchen/design');
    } else if (context === CONTEXT.STORAGE) {
      this.gtm.trackEvent("click", "home", "start-" + CONTEXT.STORAGE);
      this.router.navigateByUrl('/storage/configuration');
    } else if (context === CONTEXT.BATHROOM) {
      this.gtm.trackEvent("click", "home", "start-" + CONTEXT.BATHROOM);
      this.router.navigateByUrl('/bathroom/configuration');
    }
  }

  updateContext(context) {
    switch (context) {
      case CONTEXT.KITCHEN:
        this.customer.context = CONTEXT.KITCHEN;
        break;
      case CONTEXT.STORAGE:
        this.customer.context = CONTEXT.STORAGE;
        break; 
      case CONTEXT.BATHROOM:
        this.customer.context = CONTEXT.BATHROOM;
        break;
      default:
        break;
    }
  }

  retrieveProject() {
    this.gtm.trackEvent('click', 'project', 'open-last');
    if (this.customer.userDatas) {
      if (this.customer.userDatas.vendor && !this.customer.userDatas.otherAccount) {
        this.byMeService.byMeApiToken = null;
      }
    }
    
    this.byMeService.prepareBymeSettings(
      this.current.modelId,
      this.current.layoutRef,
      this.current.ovenConfigurationRef,
      this.current.furnitureConfiguration
    )
  }

  goProjects(context: string) {
    this.updateContext(context);

    //si l'utilisateur n'as pas de hbmId disponible (le sien ou celui d'un autre compte)    
    if (this.customer.userDatas.vendor && !this.customer.userDatas.otherAccount) {
      this.gtm.trackEvent('click', 'home', 'open-projects-' + context);
      this.modalService.display(MODAL.PROMPT, {
        contentRef: "popins.switchAccount.projects",
        buttons: [{
          labelRef: "popins.switchAccount.myAccount",//cas sur mon compte
          action: () => {
            this.modalService.close();
            //si vendeur a un compte hbm, on se connecte
            if (!this.customer.userDatas.hbmId) {
              this.byMeService.createUser(false).then(hbmUserId => {
                this.customer.userDatas.hbmId = hbmUserId;                
                  // On envoie le hbm user id à Magento.
                  this.magentoService.postMessageToMagento(
                    MAGENTO_MESSAGES.MATCH_ACCOUNT,
                    { 
                      hbm_user_id: this.customer.userDatas.hbmId, 
                      magento_id: this.customer.userDatas.magentoId,
                      role: this.customer.userDatas.vendor ? 'vendor' : 'customer'
                    });
              })
            } 
            this.openProjects(this.customer.userDatas.hbmId, context);
          }
        }, {//cas sur un autre compte : on ouvre la modale de recherche de compte
          labelRef: "popins.switchAccount.anotherAccount",
          action: () => {
            this.modalService.close();
            this.modalService.display(MODAL.SEARCH_CUSTOMER, {
              onCustomerSelect: (hbmId: string, magentoId: string, name: string, phone: string, email: string) => {
                this.modalService.close();
                if (this.customer.userDatas.magentoId != magentoId) { //on vérifie que le vendeur ne s'est pas choisi lui même
                  this.customer.userDatas.otherAccount = {
                    hbmId: hbmId,
                    completeName: name,
                    magentoId: magentoId,
                    phone: phone,
                    email: email
                  }
                }
                this.openProjects(this.customer.userDatas.otherAccount ?
                  this.customer.userDatas.otherAccount.hbmId :
                  this.customer.userDatas.hbmId, context)
              }
            });
          }
        }]
      });
    } else if (!this.byMeService.byMeApiToken) {
      this.byMeService.acquireToken(this.customer.userDatas.hbmId, false)
        .then(() => this.openProjects(this.customer.userDatas.otherAccount ?
          this.customer.userDatas.otherAccount.hbmId :
          this.customer.userDatas.hbmId, context));
    } else {
      this.openProjects(this.customer.userDatas.otherAccount ?
        this.customer.userDatas.otherAccount.hbmId :
        this.customer.userDatas.hbmId, context)
    }
  }

  private openProjects(customerId: string, context: string) {
    this.gtm.trackEvent('click', 'home', 'open-projects-' + context);
    this.updateContext(context);
    this.modalService.display(
      MODAL.PROJECTS,
      { customerId: customerId,
      tabKey: context });
  }

  isProjectButtonVisible(): boolean {
    if (this.customer.userDatas) {
      if (this.customer.userDatas.hbmId || this.customer.userDatas.vendor) {
        return true;
      }
    }
    return false;
  }
}
